import { Action } from 'redux';

import { SetExtractRefreshPriority } from '../../app/actions/AppActionTypes';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';

export interface SetExtractRefreshPriorityAction extends Action {
  tasks: IExtractTaskInfo[];
}

export function setExtractRefreshPriority(tasks: IExtractTaskInfo[]): SetExtractRefreshPriorityAction {
  return {
    type: SetExtractRefreshPriority,
    tasks
  };
}
